import { FetchArgs, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API, SEARCH_PARAMS } from '@constants/index';
import { setApiUrl } from '@utils/index';

// communityApi는 searchApi랑 params 명칭이 달라 가공 필요
const setCommunityApiParams = (params: any = {}) => {
  const newParams = {
    ...params,
    query: params?.keyword,
  };

  if (SEARCH_PARAMS.KEYWORD in params) {
    delete newParams[SEARCH_PARAMS.KEYWORD];
  }

  return newParams;
};

export const apiCommunitySlice = createApi({
  reducerPath: 'apiCommunity',
  baseQuery: fetchBaseQuery({
    baseUrl: '',
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    getBoardAlias: builder.query({
      query: ({ option, params }): FetchArgs => ({
        url: setApiUrl(`${API.COMMUNITY_BOARD_ALIAS}`, option, params),
        params: setCommunityApiParams(params),
      }),
    }),
    getCommunityAll: builder.query({
      query: ({ option, params }): FetchArgs => ({
        url: setApiUrl(`${API.COMMUNITY_API_ALL}`, option, params),
        params: setCommunityApiParams(params),
      }),
    }),
    getCommunityArticle: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(`${API.COMMUNITY_API_ARTICLE}`, option, params),
        params: setCommunityApiParams(params),
      }),
    }),
    getCommunityTag: builder.query({
      query: ({ option, params }) => ({
        url: setApiUrl(`${API.COMMUNITY_API_TAG}`, option, params),
        params: setCommunityApiParams(params),
      }),
    }),
  }),
});

export const { useGetCommunityAllQuery, useGetCommunityArticleQuery, useGetCommunityTagQuery } = apiCommunitySlice;
